export default __webpack_public_path__ + "static/media/change.7f419818.png";